import { getSiteOrigin } from "@/types/utils/seo/urls";

export interface IStructuredDataContext {
    vm?: any;
    origin?: string;
    currentPath?: string;
    currentUrl?: string;
    creator?: string;
    currentCurrency?: string;
    formatProductName: (name?: string, brand?: string) => string;
};

export interface IStructuredDataInput {
    vm: any,
    origin?: string,
    currentPath?: string,
    productCategory?: string,
    creator?: string,
    currentCurrency?: string
};

export const createStructuredDataContext = (vm?: any, origin?: string, currentPath?: string, creator?: string, currentCurrency?: string): IStructuredDataContext => {
    return {
        vm,
        origin: (origin ?? getSiteOrigin()).replace(/\/+$/, ""),
        currentUrl: `${origin}${currentPath?.startsWith("/") ? "" : "/"}${currentPath}`,
        creator: creator ?? "Cadac Group",
        currentCurrency: (currentCurrency ?? "EUR").toUpperCase(),
        formatProductName: (name?: string, brand?: string) => {
            if (!name) return brand ?? "";
            if (!brand) return name;
            return `${brand} ${name}`;
        }
    };
}